import { render } from "./alertStack.vue?vue&type=template&id=35b43b53"
import script from "./alertStack.vue?vue&type=script&lang=js"
export * from "./alertStack.vue?vue&type=script&lang=js"

import "./alertStack.vue?vue&type=style&index=0&id=35b43b53&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__